
import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Col, Row, Container, Image, Breadcrumb, Button } from 'react-bootstrap';
import artTypes from '../../components/ArtTypes';
import './AddArtPage.css';

import { ICreator } from '../../interfaces/creator.interface';

const apiUrl = process.env.REACT_APP_API_URL;

const AddArtPage: React.FC = () => {
    const { type } = useParams();

    const chosenType = artTypes.find(artType => artType.type === type);
    const [creators, setCreators] = useState<ICreator[]>([]);

    useEffect(() => {
        // Fetch creators list from API
        fetch(apiUrl + '/creators')
            .then(response => response.json())
            .then(data => setCreators(data))
            .catch(error => console.error('Error fetching creators:', error));
    }, []);

    return (
        <Container>
            <Row>
                <Col>
                    <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/database">Database</Breadcrumb.Item>
                        <Breadcrumb.Item active>{chosenType?.title}: Add a new one</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="art-database-heading">
                        <h2>
                            <Image src={chosenType?.image} roundedCircle />
                            Add new {chosenType?.title} entry
                        </h2>
                    </div>
                    <hr />
                </Col>
            </Row>
            <Row>
                <Row>
                    <Col>
                        <div className="database-action-buttons">
                            <Link to={`/arts/` + chosenType?.type}>
                                <Button variant="primary" size="sm">Back to the list</Button>
                            </Link>
                        </div>
                    </Col>
                </Row>
                <Col>
                    <p>
                        Please fill out the form below to add a new {chosenType?.title} entry to the database.
                    </p>
                    <form action="">
                        <input type="hidden" name="artType" value={chosenType?.type} />

                        <div className="mb-3">
                            <label className='form-label' htmlFor="date">Date of Creation</label>
                            <input type="date" className='form-control' id="date" name="date" />
                        </div>
                        <div className="mb-3">
                            <label className='form-label' htmlFor="creator">Creator</label>
                            <select className='form-control' id="creator" name="creator">
                                {creators.map(creator => (
                                    <option value={creator.id}>{creator.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="mb-3">
                            <label className='form-label' htmlFor="image">Image</label>
                            <input type="file" className='form-control hide' id="image" name="image" accept="image/*" />
                            <div className='dropzone'> Drag & Drop a file to upload</div>
                        </div>
                        <div className="mb-3">
                            <label className='form-label' htmlFor="influenceOn">Influence On</label>
                            <input type="text" className='form-control' id="influenceOn" name="influenceOn" />
                        </div>
                        <div className="mb-3">
                            <label className='form-label' htmlFor="influencedBy">Influenced By</label>
                            <input type="text" className='form-control' id="influencedBy" name="influencedBy" />
                        </div>
                        <div className="mb-3">
                            <label className='form-label' htmlFor="text">Descripton</label>
                            <textarea className='form-control' id="text" name="text" rows={10}></textarea>
                        </div>
                        <div className="mb-3">
                            <Button variant="primary" type="submit">
                                Add
                            </Button>
                        </div>
                    </form>

                </Col>
                <Col>
                </Col>
            </Row>
        </Container>
    );
};

export default AddArtPage;